import axios from "axios";

axios.defaults.headers.common = {
  "Access-Control-Allow-Origin": "*",
};

const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  // withCredentials: true,
});

export const openApi = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
});

export default api;
